function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * @class assetPhotos
 *
 */
import { Row, Col, Button } from 'reactstrap';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { v4 as uuidV4 } from 'uuid';
import moment from 'moment';
import PhotoItem from '../common/sections/photoItem';
import Icon from '../common/containers/icon';

// must be defined outside of the component to avoid re-rendering loops
const noop = () => {};
const defaultEntity = (assetID, appCreatorID) => {
  const createdDate = moment().utc().toISOString();
  return {
    id: uuidV4().toUpperCase(),
    appCreatorID,
    // logged in user
    appCreated: createdDate,
    created: createdDate,
    assetID
  };
};
class AssetPhotos extends Component {
  constructor(props) {
    super(props);
    this.handleAdd = this.handleAdd.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleRemove = this.handleRemove.bind(this);
    this.handleUpload = this.handleUpload.bind(this);
  }
  handleAdd() {
    const {
      assetActions,
      userID,
      asset: {
        id: assetID,
        photos
      }
    } = this.props;
    const newPhotos = JSON.parse(JSON.stringify(photos));
    newPhotos.push(defaultEntity(assetID, userID));
    assetActions.change(assetID, 'photos', newPhotos);
  }
  handleChange(photoIndex, {
    name: fieldName,
    value
  }) {
    const {
      asset: {
        id: assetID
      },
      assetActions
    } = this.props;
    assetActions.change(assetID, `photos[${photoIndex}]/${fieldName}`, value);
  }
  handleRemove(index) {
    const {
      asset: {
        id: assetID,
        photos
      },
      assetActions
    } = this.props;
    const newPhotos = JSON.parse(JSON.stringify(photos));
    newPhotos.splice(index, 1);
    assetActions.change(assetID, 'photos', newPhotos);
  }
  handleUpload(incomingItem, index, filesToUpload) {
    if (filesToUpload.length) {
      const {
        asset: {
          id: assetID
        },
        assetActions: {
          serverUpload
        }
      } = this.props;
      serverUpload(assetID, `photos/${index}/path`, `photos/${index}/tempPath`, [_objectSpread(_objectSpread({}, incomingItem), {}, {
        rawFile: filesToUpload[0],
        remotePath: `${uuidV4().toUpperCase()}.jpg`,
        type: filesToUpload[0].type
      })]);
    }
  }
  render() {
    const {
      asset: {
        photos
      },
      loading
    } = this.props;
    return /*#__PURE__*/React.createElement("section", null, /*#__PURE__*/React.createElement("h2", null, "Photos"), /*#__PURE__*/React.createElement("hr", null), (photos || []).map((item, index) => /*#__PURE__*/React.createElement(PhotoItem, {
      data: item,
      index: index,
      key: item.id,
      loading: loading,
      onChange: this.handleChange,
      onRemove: this.handleRemove,
      onUpload: this.handleUpload,
      setSaveStatus: noop,
      includeDivider: true,
      hasCaption: true,
      className: `t-api-${index}`
    })), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
      sm: {
        size: 3,
        offset: 9
      }
    }, /*#__PURE__*/React.createElement(Button, {
      className: "form-control addIssuePhoto t-ip-add-photo tqc-control",
      size: "sm",
      onClick: this.handleAdd
    }, /*#__PURE__*/React.createElement(Icon, {
      glyph: "plus"
    }), " Add Photo"))));
  }
}
AssetPhotos.propTypes = {
  asset: PropTypes.shape({
    id: PropTypes.string,
    photos: PropTypes.arrayOf(PropTypes.shape({}))
  }).isRequired,
  assetActions: PropTypes.shape({
    serverUpload: PropTypes.func,
    create: PropTypes.func,
    change: PropTypes.func
  }).isRequired,
  loading: PropTypes.bool.isRequired,
  userID: PropTypes.string.isRequired
};
export default AssetPhotos;